module.exports = __webpack_public_path__ + "static/img/bg_about_c.907d5a3a.png";